export class Contact {

	public name: string;

	public position: string;

	public email: string;

	public phone: string | undefined;

}



// WEBPACK FOOTER //
// ./Frontend/src/entity/Contact.ts